import React from "react";
import { container } from "@/utils/mobx";
import { ActivityBarStore } from "./store";
import { Clickable } from "@/components/toolkit/Clickable";
import { t } from "@/i18n";

export const SetupAgentModal = container((props: { store: ActivityBarStore }) => {
    const store = props.store;

    if (!store.isSetupAgentModalOpen) return null;

    const selectAll = (e: React.MouseEvent | React.FocusEvent) => {
        const el = e.currentTarget as HTMLElement;
        const sel = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(el);
        sel?.removeAllRanges();
        sel?.addRange(range);
    };

    return (
        <div className="activity_bar__dialog_overlay" onMouseDown={() => store.closeSetupAgentModal()}>
            <div className="activity_bar__dialog activity_bar__setup_agent_modal" onMouseDown={e => e.stopPropagation()}>
                <div className="activity_bar__dialog_title">{t("setup_agent_title")}</div>

                <div className="activity_bar__dialog_body">
                <div className="activity_bar__setup_step_title">{t("setup_agent_install_title")}</div>
                <code className="activity_bar__setup_code" tabIndex={0} onClick={selectAll} onFocus={selectAll}>{t("setup_agent_install_cmd")}</code>

                <div className="activity_bar__setup_step_title">{t("setup_agent_run_title")}</div>
                <div className="activity_bar__setup_step_desc">{t("setup_agent_run_desc")}</div>
                <div className="activity_bar__setup_token_row">
                    <span className="activity_bar__setup_token_label">{t("setup_agent_token_label")}:</span>
                    <code className="activity_bar__setup_token" tabIndex={0} onClick={selectAll} onFocus={selectAll}>{store.token}</code>
                </div>
                <pre className="activity_bar__setup_code activity_bar__setup_code--block" tabIndex={0} onClick={selectAll} onFocus={selectAll}>{
                    t("setup_agent_env_block")
                        .replace("{token}", store.token ?? "")
                        .replace("{apiUrl}", store.apiUrl)
                }</pre>
                </div>

                <div className="activity_bar__dialog_actions">
                    <Clickable onClick={() => store.closeSetupAgentModal()}>
                        <button className="activity_bar__dialog_btn activity_bar__dialog_btn--create">{t("setup_agent_close")}</button>
                    </Clickable>
                </div>
            </div>
        </div>
    );
}, ActivityBarStore);
